import { Chip, formatDate, Show } from '@side/pantry';
import { useRouter } from 'next/router';
import { getFullName } from '@/common/utils/person';
import { BaseSideNavigation } from '@/components/BaseSideNavigation/BaseSideNavigation';
import { Link } from '@/components/SideBar/components/Link';
import { TXM_TEMPLATES_PATH } from '@/constants';
import { useGetTemplateDetails } from '@/views/Templates/hooks/useGetTemplateDetails';
import { TemplateFolderSvg } from '../../TemplateFolderSvg';

export function SidebarContent() {
  const { template } = useGetTemplateDetails({
    loadCreatedByData: true,
  });
  const { basePath: txmBasePath } = useRouter();
  const basePath = `${txmBasePath}${TXM_TEMPLATES_PATH}/${template?.id}`;

  const creatorName = getFullName(
    template?.createdBy?.firstName,
    template?.createdBy?.lastName,
  );

  return (
    <BaseSideNavigation
      Icon={<TemplateFolderSvg />}
      title={template?.name}
      subtitle={
        template?.createdBy
          ? `Created by: ${creatorName} on
                  ${formatDate(template.createdAt, 'shortDate')}`
          : undefined
      }
      extraHeaderContent={
        <Show when={template?.isReadOnly}>
          <Chip
            label="This template is read only"
            variant="outlined"
            sx={{
              borderRadius: 0.5,
              alignSelf: 'start',
            }}
          />
        </Show>
      }
      headerSx={{ alignItems: 'flex-start' }}
    >
      <Link
        path={basePath}
        label="Template Details"
        interactionId={template?.id}
      />
      <Link path={`${basePath}/documents`} label="Documents" />
    </BaseSideNavigation>
  );
}
